var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 110,
    viewBox: "0 0 159 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.798 15.492C135.232 15.3499 117.399 14.9357 116.018 15.0422C116.018 15.0422 114.904 7.4613 114.371 5.18289C114.171 4.33662 113.614 1.63212 112.96 0.247314H106.723C105.99 2.04637 105.373 4.67395 105.155 5.69775C104.622 8.18921 103.968 12.604 103.592 15.0422C103.592 15.0422 87.3214 15.4032 84.2452 15.5334C83.6458 15.5571 71.4258 15.8885 61.18 17.1727V21.1199C70.0633 22.3035 88.3872 22.3746 92.7653 22.4101C94.2489 22.4219 103.913 22.4101 104.337 22.4101C104.337 22.4101 105.473 34.3923 108.403 43.5355H112.14C113.323 37.6326 114.371 30.7458 115.164 22.3035C115.164 22.3035 129.807 22.3035 135.226 22.3035C141.93 22.3035 152.23 22.0076 158.522 20.972V17.368C153.526 16.4152 143.316 15.6044 139.792 15.492H139.798Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.431415,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9622 37.313L55.5264 70.7952",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "5 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2852 56.1096H16.114V70.2808H30.2852V56.1096Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25177 109.116V86.0698H39.5165V109.116",
    stroke: "black",
    strokeWidth: 12.91,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRps);
export default __webpack_public_path__ + "static/media/RPS.2c385d20.svg";
export { ForwardRef as ReactComponent };